import React from "react";
import {
  DISPLAY_PERCENTAGE,
  DISPLAY_VALUES,
  PERCENTAGE_OF_COLUMN,
  PERCENTAGE_OF_ROW,
} from "./customReportValueDisplay.js";

const MeasureDisplayModeControls = ({
  mode = DISPLAY_VALUES,
  percentageOf = PERCENTAGE_OF_COLUMN,
  allowRow = false,
  onChange,
}) => (
  <div className="flex flex-wrap items-center gap-2" aria-label="Measure display settings">
    <div className="inline-flex overflow-hidden rounded-md border border-gray-200" role="group" aria-label="Display mode">
      {[
        { value: DISPLAY_VALUES, label: "Values" },
        { value: DISPLAY_PERCENTAGE, label: "Percentage" },
      ].map((option) => (
        <button
          key={option.value}
          type="button"
          aria-pressed={mode === option.value}
          onClick={() => onChange({ mode: option.value })}
          className={`px-3 py-1.5 text-xs ${
            mode === option.value
              ? "bg-indigo-50 text-indigo-700"
              : "bg-white text-gray-600 hover:bg-gray-50"
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
    {mode === DISPLAY_PERCENTAGE ? (
      <label className="flex items-center gap-1.5 text-xs text-gray-600">
        <span>Percentage of</span>
        <select
          aria-label="Percentage of"
          value={allowRow ? percentageOf : PERCENTAGE_OF_COLUMN}
          disabled={!allowRow}
          onChange={(event) => onChange({ percentageOf: event.target.value })}
          className="rounded-md border border-gray-200 bg-white px-2 py-1.5 text-xs text-gray-700 disabled:bg-gray-50"
        >
          {allowRow ? <option value={PERCENTAGE_OF_ROW}>Row</option> : null}
          <option value={PERCENTAGE_OF_COLUMN}>Column</option>
        </select>
      </label>
    ) : null}
  </div>
);

export default MeasureDisplayModeControls;
